module.exports = __webpack_public_path__ + "img/service-zhinengcuishou1.b120a535.svg";